import { ResultsMenu } from '~/web-frontend-core/store/results/live/Menu';
import { ResultsTables } from '~/web-frontend-core/store/results/live/Tables';
export class ResultsLive {
    constructor(cfg) {
        this.tables = new ResultsTables(cfg);
        this.menu = new ResultsMenu(cfg);
    }
    clear() {
        this.menu.clear();
        this.tables.clear();
    }
    /**
     * Подписка на обновления таблицы live доп.исходов через WS
     */
    listenWS(cfg = {}) {
        this.menu.listenWS(cfg);
    }
    stopListenWS() {
        this.menu.stopListenWS();
        this.tables.stopListenWS();
    }
    static getInstance(cfg) {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new ResultsLive(cfg);
        return this.instance;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/results/ResultsLive.js